"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const utils_1 = require("../../lib/utils");
const BoardCertificationEntry = ({ board_certification }) => {
    const { specialty_name, board_name, year_certified } = board_certification;
    const boardNameMarkup = board_name ? (react_1.default.createElement("span", { itemProp: "recognizedBy" }, board_name)) : null;
    const yearCertifiedMarkup = year_certified ? (react_1.default.createElement("span", { itemProp: "dateCreated" }, year_certified)) : null;
    return (react_1.default.createElement(styles_1.ExpertiseEntryContainer, { itemProp: "hasCredential", itemScope: true, itemType: "https://schema.org/EducationalOccupationalCredential" },
        react_1.default.createElement(styles_1.ExpertiseEntryHeader, { itemProp: "about" }, specialty_name),
        react_1.default.createElement(styles_1.ExpertiseEntryCopy, null, (0, utils_1.insertBetweenItems)([boardNameMarkup, yearCertifiedMarkup].filter(Boolean), ', '))));
};
exports.default = BoardCertificationEntry;
//# sourceMappingURL=board-certification-entry.js.map